import { validEmail } from './validate'

const Validator = {
    // 手机规则校验器
    getMobileValidator() {
        const isMobile = /^1[3-9][0-9]\d{8}$/
        let validMobile = (rule, value, callback) => {
            // if (!value) {
            //     callback(new Error('请输入手机号码'))
            // } else
           if (value && !isMobile.test(value)) {
                callback(new Error('请输入正确的11位手机号码'))
            } else {
                callback()
            }
        }
        return validMobile
    },
  //用户名规则校验器
  getUserNameValidator(){
    const isUserName = /^[\u4E00-\u9FA5]+$/
    let validUserName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入用户名'))
      } else if (!isUserName.test(value)) {
        callback(new Error('用户名只能为中文'))
      } else {
        callback()
      }
    }
    return validUserName
  },

  //数字（正整数和0）规则校验器
  getIntegerValidator() {
    const isInteger = /^([1-9]\d*|[0]{1,1})$/;
    let validInteger = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入数字'))
      } else if (!isInteger.test(value)) {
        callback(new Error('请输入正确数字'))
      } else {
        callback()
      }
    }
    return validInteger
  },
  //身份证号规则校验器
  getCardIDValidator() {
    const isCardID = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    let validCardID = (rule, value, callback) => {
      // if (!value) {
      //   callback(new Error('请输入身份证号'))
      // } else
      if (value && !isCardID.test(value)) {
        callback(new Error('您输入的身份证号不正确!'))
      } else {
        callback()
      }
    }
    return validCardID
  },
  //qq号规则校验器
  getQQValidator() {
    const isQQ = /^[1-9][0-9]{4,10}$/;
    let validQQ = (rule, value, callback) => {
      if (!value) {
        callback(new Error('您输入的QQ号'))
      } else if (!isQQ.test(value)) {
        callback(new Error('您输入的QQ号不正确'))
      } else {
        callback()
      }
    }
    return validQQ
  },

  //车牌号规则校验器
  getVehicleNoValidator() {
    // const isVehicleNo = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z][A-Z])[-]?|([wW][Jj][京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z][-]?)|([a-zA-Z]{2}))([A-Za-z0-9]{5}|[DdFf][A-HJ-NP-Za-hj-np-z0-9][0-9]{4}|[0-9]{5}[DdFf])$/;
    const isVehicleNo = /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z][A-Z])[-]?([A-Za-z0-9]{5}[A-Za-z0-9]?)$/;
    let validVehicleNo = (rule, value, callback) => {
      if (value && !isVehicleNo.test(value)) {
        callback(new Error('您输入的车牌号格式不正确!'))
      } else {
        callback()
      }
    }
    return validVehicleNo
  },

  //邮箱规则校验器
  getEmailValidator() {
    let rule = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入您的邮箱!'))
      } else if (!validEmail(value)) {
        callback(new Error('您输入的邮箱格式不正确!'))
      } else {
        callback()
      }
    }
    return rule
  },

  //座机号规则校验器
  getPhoneValidator(){
    const isPhone = /^0\d{2,3}-\d{7,8}$/
    let validPhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入座机号码'))
      } else if (!isPhone.test(value)) {
        callback(new Error('请输入正确的座机号码'))
      } else {
        callback()
      }
    }
    return validPhone
  },
  //货币数字（最多带两位小数）
  getMoneynumValidator(){
    const isMoneynum = /^([1-9]\d*|0)(\.[\d]{1,2})?$/
    let validMoneynum = (rule, value, callback) => {
      value=value+"";
      if (!value) {
        callback(new Error('请输入数字'))
      } else if (!isMoneynum.test(value)) {
        callback(new Error('请输入正确的数字，最多保留两位小数!'))
      } else {
        callback()
      }
    }
    return validMoneynum
  },

  //数字（最多带两位小数）
  getNumberValidator(){
    const isNumber = /^([1-9]\d*|0)(\.[\d]{1,2})?$/
    let validNum = (rule, value, callback) => {
      if (value && !isNumber.test(value)) {
        callback(new Error('请输入正确的数字，最多保留两位小数!'))
      } else {
        callback()
      }
    }
    return validNum
  },

  //密码规则校验器
  getPassWordValidator(){
    const isPassword = /^(\w){6,20}$/
    let validPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (!isPassword.test(value)) {
        callback(new Error('只能输入6-20个字母、数字、下划线'))
      } else {
        callback()
      }
    }
    return validPassword
  },
}
//
const context = require.context('@/page', true, /\.ru.js$/);
const moduleStores = {};
context.keys().forEach(key => {
  const fileName = key.split('/');
  const size = fileName.length;
  const modName = fileName[size-1].split('.')[0];
  const fileModule = context(key).default;
  moduleStores[modName] = {
    ...fileModule,
  };
});
//
let newObj = {};
for(let i in moduleStores){
  Object.assign(newObj,moduleStores[i])
}


export default {
  install: function(Vue, Option) {
    Object.defineProperty(Vue.prototype, "$valid", { value: {...Validator, ...newObj,}  });
  }
};



// WEBPACK FOOTER //
// ./src/utils/validator-plugin.js